import { plansService } from '@/services/tmed-plans/plan.service';

export default {
  namespaced: true,
  state: {
    plansRequestStatus: 'init',
    plans: null,
    currentPlan: null,
  },
  getters: {
    getPlansRequestStatus(state) {
      return state.plansRequestStatus;
    },
    getPlans(state) {
      return state.plans;
    },
    getCurrentPlan(state) {
      return state.currentPlan;
    },
  },
  mutations: {
    PLANS_STATUS(state, value) {
      state.plansRequestStatus = value;
    },
    SET_PLANS(state, plans) {
      state.plans = plans;
    },
    SET_CURRENT_PLAN(state, plan) {
      state.currentPlan = plan;
    },
  },
  actions: {
    setCurrentPlan({ commit }, plan) {
      commit('SET_CURRENT_PLAN', plan);
    },

    async getAllPlans({ commit }, params) {
      commit('PLANS_STATUS', 'pending');
      try {
        const { data } = await plansService.getAllPlans(params);
        commit('PLANS_STATUS', 'init');
        commit('SET_PLANS', data.items || data);
        return data;
      } catch (error) {
        commit('PLANS_STATUS', 'init');
        return Promise.reject(error);
      }
    },
  },
};
